import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getNormativeEstablishmentList as getNormativeEstablishmentListApi,
	getNormativeEstablishment as getNormativeEstablishmentApi,
	addNewNormativeEstablishment as addNewNormativeEstablishmentApi,
	updateNormativeEstablishment as updateNormativeEstablishmentApi,
	deleteNormativeEstablishment as deleteNormativeEstablishmentApi,
	getNormativeEstablishmentDetail as getNormativeEstablishmentDetailApi,
} from '../../helpers/normative/backend_helper';

export const getNormativeEstablishmentList = createAsyncThunk('normativeEstablishments/getNormativeEstablishmentList', async () => {
	try {
		const response = getNormativeEstablishmentListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getNormativeEstablishment = createAsyncThunk('normativeEstablishments/getNormativeEstablishment', async normativeEstablishment_id => {
	try {
		const response = getNormativeEstablishmentApi(normativeEstablishment_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewNormativeEstablishment = createAsyncThunk('normativeEstablishments/addNewNormativeEstablishment', async normativeEstablishment => {
	try {
		const response = addNewNormativeEstablishmentApi(normativeEstablishment);
		toast.success('NormativeEstablishment agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar normativeEstablishment.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateNormativeEstablishment = createAsyncThunk('normativeEstablishments/updateNormativeEstablishment', async (normativeEstablishment) => {
	try {
		const response = updateNormativeEstablishmentApi(normativeEstablishment);
		toast.success('NormativeEstablishment actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar normativeEstablishment.', { autoClose: 3000 });
		throw new Error(error);
	}
}
);

export const deleteNormativeEstablishment = createAsyncThunk('normativeEstablishments/deleteNormativeEstablishment', async normativeEstablishment => {
	try {
		const response = await deleteNormativeEstablishmentApi(normativeEstablishment);
		toast.success('NormativeEstablishment eliminado exitosamente.', { autoClose: 3000 });
		return { normativeEstablishment, ...response };
	} catch (error) {
		toast.error('Error al eliminar normativeEstablishment.', { autoClose: 3000 });
		throw new Error(error);
	}
});


export const getNormativeEstablishmentDetail = createAsyncThunk('normativeEstablishments/getNormativeEstablishmentDetail', async normativeEstablishment_id => {
	try {
		const response = getNormativeEstablishmentDetailApi(normativeEstablishment_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});
